import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LoginService } from 'src/app/managers/login.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { ClientConfigService } from 'src/app/common/services/client-config.service';

@Component({
  selector: 'app-app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.css']
})
export class AppMenuComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {  
  showHome: boolean;
  showLogin: boolean;
  showAdmin: boolean;
  nickName: string;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _router: Router, 
              private _snackBar: MatSnackBar) {
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.refresh();  
  }

  ngOnChanges() {
    this.refresh();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private refresh() {     
    this.showHome = this.parentComponent === 'home' ? false : true;
    this.showLogin = this.parentComponent === 'login' ? false : (this.dataSource.Id === 0 ? true : false);
    this.showAdmin = this.parentComponent === 'admin' ? false : (this.dataSource.Id === 0 ? false: this.dataSource.IsAdmin);      
    this.nickName = this.getNickName();  
  }

  private getNickName(): string {    
    if (this.dataSource.Id !== 0) {  
      let str = this.dataSource.Email.split('@', 2);
      return str[0];
    }
    else
      return '';   
  }

  async logoutAsync() {
    this._snackBar.open('Signing out...');
    let responseMsg = await this.loginManager.logoutAsync();
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this.dataSource = this.getLoggedinUser();
      this.refresh();
      this._snackBar.open('Signed out successfully', 'Ok', { duration: 5000 });      
      
      /*
      we want to stay in the root url to prevent the error of 404 file or directory not found when users refresh page from a browser. 
      this._router.navigate(['/home']);
      */
      this._router.navigate(['']);
    }
    else {
      this._snackBar.open('Failed to sign out: ' + responseMsg.Message, 'Ok', { duration: 5000 });
      this.handleCoreResponseMessageError(responseMsg);
    }   
  }

  clearUser() {
    this.loginManager.clearUser();
    this.dataSource = this.getLoggedinUser();
    this.refresh();

    /*
    we want to stay in the root url to prevent the error of 404 file or directory not found when users refresh page from a browser. 
    this._router.navigate(['/home']);
    */
    this._router.navigate(['']);
  }
}
